import { Fragment, useEffect, useState } from "react";
import { useMatch, useNavigate } from "react-router";
import { findIndex, first, replace, flatMap, map } from 'lodash';
import { Paths } from "../routes/Routes";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useLazyQuery } from "@apollo/client";
import { GET_USERS } from "../../graphQL/queries";
import { User } from "../../models/User";
import { NoContentWrapper, getTrendClass, renderPeriod } from "../../helpers/renderHelper";
import LoadingSpinner from "../common/LoadingSpinner";
import { setUsers } from "../../redux/appStateSlice";
import DriverCard from "../common/DriverCard";
import IncidentCard from "../common/IncidentCard";
import { buildIncidents } from "../../helpers/incidentHelper";
import { buildGroupDrivers } from "../../helpers/managerHelper";
import { navigatToDriverDetail } from "../../helpers/navigationHelper";
import { incrementBackNavigation } from "../../redux/navigationSlice";
import { Stack } from "react-bootstrap";
import ScoreTile from "../common/ScoreTile";
import { AppMessages } from "../../strings";
import RankProgress from "../common/RankProgress";

const ManagerDriverDetail = () => {

	const driverDetailMatch = useMatch(Paths.MANAGER_DRIVER_DETAIL);
	const navigate = useNavigate()
	const dispatch = useAppDispatch();
	const currentGroupID = parseInt(driverDetailMatch?.params.groupid ?? "-1")

	const [currentDriver, setCurrentDriver] = useState<User|undefined>()
	const currentOrganization = useAppSelector(state => state.appState.currentOrganization);
	const allDrivers = useAppSelector(state => state.appState.groupUsers[currentGroupID]?.users)
	const drivers = buildGroupDrivers(allDrivers);

	const [getDriver, driverResponses ] = useLazyQuery(GET_USERS, 
		{ variables: { 
			userID: parseInt( driverDetailMatch?.params.id ?? "-1"), 
			onlyDrivers: true,
			startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
			endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
			prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
			prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
		} 
	});

	const [getDrivers, getDriversResponses ] = useLazyQuery(GET_USERS, 
		{ variables: { 
			groupID: currentGroupID, 
			onlyDrivers: true,
			startDate: process.env.REACT_APP_MANAGER_START_DATE ? process.env.REACT_APP_MANAGER_START_DATE : null ,
			endDate: process.env.REACT_APP_MANAGER_END_DATE ? process.env.REACT_APP_MANAGER_END_DATE : null,
			prevStartDate: process.env.REACT_APP_MANAGER_PREV_START_DATE ? process.env.REACT_APP_MANAGER_PREV_START_DATE : null,
			prevEndDate: process.env.REACT_APP_MANAGER_PREV_END_DATE ? process.env.REACT_APP_MANAGER_PREV_END_DATE : null
		} 
	});

	useEffect(()=> {
		getDriver();
	},[]);

	useEffect(() => {
		if (driverResponses?.data) {
			// console.log('driverResponses?.data = ', driverResponses?.data)
			const driver = first(driverResponses?.data.users)
			if (driver) {
				setCurrentDriver(driver)
				console.log("called get all drivers")
				getDrivers()	
			}
		}
	},[driverResponses?.data])

	useEffect(()=>{
		if (getDriversResponses?.data) {
			//dispatch(setDrivers(getDriversResponses?.data));
			dispatch(setUsers({groupId: currentGroupID, groupUsers:getDriversResponses?.data}))
		}
	},[getDriversResponses?.data])


	var	score = currentDriver?.scorecard

	const currentIndex = findIndex(drivers, driver => driver.userID === currentDriver?.userID)
	const isFirst = drivers.length ? currentIndex === 0 : true;
	const isLast =  drivers.length ? currentIndex === (drivers?.length - 1) : true;

	// const incidents = flatMap(currentDriver?.scorecard, sc => sc.incidents)
	const incidents = currentDriver?.scorecard?.incidents
	const filteredIncidents = buildIncidents(incidents)

	function navigateTo(e, user) {
		navigatToDriverDetail(e, user, Paths.MANAGER_DRIVER_DETAIL, currentGroupID, navigate, dispatch)
		dispatch(incrementBackNavigation())
	}

	function navigateToIncidentDetail(e, incident) {
		const path = replace(Paths.MANAGER_DRIVER_INCIDENT_DETAIL, ':id', currentDriver?.userID).replace(':groupid', currentGroupID).replace(':name', incident.name);
		navigate(path);
	}

	return (
		<Fragment>
			{ driverResponses.loading && <LoadingSpinner />}
			<div className="container" >
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body align-items-center" style={{padding: "0.35rem", marginBottom:-6}}>
								<DriverCard  user={ currentDriver} isFirst={isFirst} isLast={isLast} carouselMode={true} navigateLeft={ e => navigateTo(e, drivers[currentIndex - 1]) } navigateRight={ e => navigateTo(e, drivers[currentIndex + 1]) } />
							</div>
						</div>
						
					</div>
				</div>
				{ renderPeriod(currentOrganization) }
				<div className="row">
					<div className="col-12">
						<div className="card" style={{marginBottom: "0 0 0 0 !important"}}>
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row text-center g-0 p-0" >
									
									<ScoreTile score={score} />
									<RankProgress score={score} />
									
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-12">
						<div className="card" >
							<div className="card-body align-items-center" style={{padding: "0.35rem"}}>
								<div className="row g-0 p-0">
									<NoContentWrapper items={filteredIncidents} message={currentDriver?.scorecard?.currentScore ? AppMessages.noIncidents : AppMessages.noDriverScore} showIcon={currentDriver?.scorecard?.currentScore ? true : false}>
										{ map(filteredIncidents,(incident,index) => {
											return <IncidentCard key={`driver-553-${index}`} currentIncident={incident} onClick={e => navigateToIncidentDetail(e, incident)}/>
										})}
									</NoContentWrapper>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default ManagerDriverDetail;